<div class="main-container">
  <mat-toolbar color="primary">
    {{ 'scheduler.about.title' | translate }} {{ 'scheduler.title' | translate }}
  </mat-toolbar>

  <mat-tab-group backgroundColor="primary" [mat-align-tabs]="'center'" [mat-stretch-tabs]="false">

    <mat-tab label="Change Log">
      <div class="info-content">
        <h1>Change Log</h1>
        <h2>Client</h2>
        <div markdown src="CHANGELOG.md"></div>

        <h2>Server Log</h2>
        {{ serverChangeLog }}
      </div>
    </mat-tab>

    <mat-tab label="Client Information">
      <div class="info-content">
        <h1>Client Information</h1>
        <p>This web client is developed in Angular 15, using a variety of Open and Commercial Components</p>

        <p>The interactive timeline views use a licensed component called <a href="https://www.bryntum.com/">Bryntum
            Scheduler</a>.</p>

        <p>Open Source Licensing Information</p>

        <pre>
        {{ licenseInfo }}
      </pre>
      </div>
    </mat-tab>
    <mat-tab label="Server Information">
      <div class="info-content">
        <h1>Server Information</h1>

        <p>The services were written in Java, using the Spring Framework.</p>

        <p>The heuristic solver was implemented using <a href="https://optaplanner.org">OptaPlanner</a></p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>